import * as React from 'react';
import LoginButtons from "../admin/sidebar/items/LoginButtons";
import ClickableLink from "../utilities/ClickableLink";
import {useStores} from "../../stores/useStores";

const LoginBox: React.FC<{
    customHeader?: string,
    handleSkipLogin?: () => void,
}> = props => {
    const {organizationStore} = useStores();

    return <div id="sb-main-content" className="sb-login-container sb-content-width"
                style={{maxWidth: "600px", minHeight: 0}}>
        <div className="sb-login-block">
            <div className="sb-login-school-header">
                {props.customHeader ? <>
                    <h3 style={{color: "#666", paddingTop: "1em"}}>{props.customHeader}</h3>
                    {props.handleSkipLogin && <>
                        <br/>
                        <ClickableLink
                            href="https://www.youtube.com/watch?v=KUnXyXe44sk&feature=youtu.be&list=PL7UVuLpQNJqCth_6IINT1_VdLhq29ePwT">
                            Click here for a movie that describes<br/>the benefits of logging in.
                        </ClickableLink>
                    </>}
                </> : <>
                    <h2 className="sb-organization-color-block-font notranslate" style={{marginTop: "0.5em", fontWeight: "bold"}}>
                        {organizationStore.organization.title || ""}
                    </h2>
                    <h3 style={{marginTop: "0.5em"}}>Sign In</h3>
                </>}
            </div>
            <div className="sb-login-options">
                <LoginButtons/>
                {props.handleSkipLogin && <button onClick={props.handleSkipLogin}
                                          aria-label="Skip login">
                    <div className="sb-login-button sb-background-color-skip-login">
                        <div className="sb-login-button-text sb-login-button-text-skip">Skip Login</div>
                    </div>
                </button>}
            </div>
        </div>
    </div>
}

export default LoginBox;
